/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metric_Avg_Tx_Fee_Native_NameInputs */



/**
* | output |
* | --- |
* | "Average Transaction Fee" |
*
* @param {Metric_Avg_Tx_Fee_Native_NameInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metric_avg_tx_fee_native_name = /** @type {((inputs?: Metric_Avg_Tx_Fee_Native_NameInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Avg_Tx_Fee_Native_NameInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Average Transaction Fee")
});